module.exports = __webpack_public_path__ + "media/images/endia_brochure-70d93f7e1f7f16e767beb3618e0390ea.png";